import { Coachmark, DirectionalHint, FontIcon, Stack, Image, Text } from "@fluentui/react";
import { useBreakpoint } from "../../../Common/Container/ContainerStyles";
import { Breakpoint, BreakpointType, GetBreakpoint } from "../../../Common/Container/ContainerFluid";
import { useEffect, useRef, useState } from "react";
import MediaQuery from "react-responsive";
import { buttonContainerDisabledStyles, buttonContainerHighlightStyles, buttonContainerStyles, buttonDisabledSubtitleStyles, buttonDisabledTitleStyles, buttonSubtitleStyles, buttonTextContainerStyles, buttonTitleStyles, iconDisabledStyles, iconStyles, imgIconStyles, lgButtonDisabledSubtitleStyles, lgButtonDisabledTitleStyles, lgButtonSubtitleStyles, lgButtonTitleStyles, lgIconDisabledStyles, lgIconStyles, lgImgIconStyles, mdButtonDisabledSubtitleStyles, mdButtonDisabledTitleStyles, mdButtonSubtitleStyles, mdButtonTitleStyles, mdIconDisabledStyles, mdIconStyles, mdImgIconStyles, smButtonDisabledSubtitleStyles, smButtonDisabledTitleStyles, smButtonSubtitleStyles, smButtonTitleStyles, smIconDisabledStyles, smIconStyles, smImgIconStyles, xlButtonDisabledSubtitleStyles, xlButtonDisabledTitleStyles, xlButtonSubtitleStyles, xlButtonTitleStyles, xlIconDisabledStyles, xlIconStyles, xlImgIconStyles, xxlButtonDisabledSubtitleStyles, xxlButtonDisabledTitleStyles, xxlButtonSubtitleStyles, xxlButtonTitleStyles, xxlIconDisabledStyles, xxlIconStyles, xxlImgIconStyles } from "../Styles/CustomerDashboardStyles";
import { SystemDataLoadingStatus } from "../../../../Model/SystemModels";
import { SystemCore } from "../../../../Core/System/SystemCore";

export interface IDashboardButtonsProps {
    title: string;
    subtitle: string;
    icon: string;
    img? : string;
    highlight?: boolean;
    enabled?: boolean;
    onRenderRightElement?: () => JSX.Element;
    onClick: () => void;
}

export const DashboardButton: React.FC<IDashboardButtonsProps> = (props) => {
    const isXXL = useBreakpoint(BreakpointType.xxl);
    const isXL = useBreakpoint(BreakpointType.xl);
    const isLG = useBreakpoint(BreakpointType.lg);
    const isMD = useBreakpoint(BreakpointType.md);
    const isSM = useBreakpoint(BreakpointType.sm);

    return (
        <Stack
            grow
            className={props.highlight ? buttonContainerHighlightStyles : !props.enabled ? buttonContainerDisabledStyles : buttonContainerStyles}
            onClick={() => props.enabled && props.onClick()}
        >
            <Stack
                horizontal
                horizontalAlign="space-between"
                verticalAlign="center"
                verticalFill
            >
                <Stack
                    horizontal
                    horizontalAlign="start"
                    verticalAlign="center"
                    verticalFill

                    className={buttonTextContainerStyles}
                >
                    {
                        props.img ?
                            <Image 
                                src={props.img} 
                                alt=""
                                styles={
                                    isSM ? 
                                        smImgIconStyles : 
                                    isMD ? 
                                        mdImgIconStyles : 
                                    isLG ? 
                                        lgImgIconStyles : 
                                    isXL ? 
                                        xlImgIconStyles :
                                    isXXL ?
                                        xxlImgIconStyles
                                    : 
                                        imgIconStyles
                                }
                            />
                        :
                            <FontIcon
                                iconName={props.icon}
                                className={
                                    !props.enabled ? 
                                        isSM ? 
                                            smIconDisabledStyles : 
                                        isMD ? 
                                            mdIconDisabledStyles : 
                                        isLG ? 
                                            lgIconDisabledStyles : 
                                        isXL ? 
                                            xlIconDisabledStyles : 
                                        isXXL ? 
                                            xxlIconDisabledStyles
                                        : 
                                            iconDisabledStyles 
                                    : 
                                        isSM ? 
                                            smIconStyles : 
                                        isMD ? 
                                            mdIconStyles : 
                                        isLG ? 
                                            lgIconStyles : 
                                        isXL ? 
                                            xlIconStyles :
                                        isXXL ?
                                            xxlIconStyles
                                        : 
                                            iconStyles
                                }
                            />
                    }
                    <Stack
                        verticalFill
                        verticalAlign="center"
                    >
                        <Text
                            className={
                                !props.enabled ? 
                                    isSM ? 
                                        smButtonDisabledTitleStyles : 
                                    isMD ? 
                                        mdButtonDisabledTitleStyles : 
                                    isLG ?
                                        lgButtonDisabledTitleStyles :
                                    isXL ?
                                        xlButtonDisabledTitleStyles : 
                                    isXXL ?
                                        xxlButtonDisabledTitleStyles 
                                    :
                                        buttonDisabledTitleStyles 
                                : 
                                    isSM ? 
                                        smButtonTitleStyles : 
                                    isMD ?
                                        mdButtonTitleStyles :
                                    isLG ? 
                                        lgButtonTitleStyles :
                                    isXL ?
                                        xlButtonTitleStyles : 
                                    isXXL ?
                                        xxlButtonTitleStyles 
                                    :
                                        buttonTitleStyles
                            }
                        >
                            {props.title}
                        </Text>
                        <Text
                            className={
                                !props.enabled ?
                                    isSM ? 
                                        smButtonDisabledSubtitleStyles : 
                                    isMD ? 
                                        mdButtonDisabledSubtitleStyles : 
                                    isLG ?
                                        lgButtonDisabledSubtitleStyles :
                                    isXL ?
                                        xlButtonDisabledSubtitleStyles :
                                    isXXL ?
                                        xxlButtonDisabledSubtitleStyles 
                                    :
                                        buttonDisabledSubtitleStyles
                                :
                                    isSM ? 
                                        smButtonSubtitleStyles : 
                                    isMD ? 
                                        mdButtonSubtitleStyles : 
                                    isLG ?
                                        lgButtonSubtitleStyles :
                                    isXL ? 
                                        xlButtonSubtitleStyles :
                                    isXXL ?
                                        xxlButtonSubtitleStyles 
                                    :
                                        buttonSubtitleStyles
                            }
                        >
                            {props.subtitle}
                        </Text>
                    </Stack>
                </Stack>
                <Stack>
                    {
                        props.onRenderRightElement && props.onRenderRightElement()
                    }
                </Stack>
            </Stack>
        </Stack>
    );
};